import { atom } from 'jotai'

export const nutritionAtom = atom([])